<template>
  <v-container fluid grid-list-sm>
    <v-subheader>
      <v-icon class="mr-1" color="teal">new_releases</v-icon>
      科研成果
    </v-subheader>
    <v-divider color="lightgrey"/>
    <v-layout row wrap>
      <v-flex xs6 sm4 md2 lg2>
        <v-btn
          flat large
          to="/staff/print/self">
          <v-icon large color="teal">print</v-icon>
          业绩打印
        </v-btn>
      </v-flex>

      <v-flex xs6 sm4 md2 lg2>
        <v-btn
          flat large
          to="/papr/personal">
          <v-icon large color="blue">file_copy</v-icon>
          论文管理
        </v-btn>
      </v-flex>

      <v-flex xs6 sm4 md2 lg2>
        <v-btn
          flat large
          to="/book/personal">
          <v-icon large color="orange">book</v-icon>
          论著管理
        </v-btn>
      </v-flex>

      <v-flex xs6 sm4 md2 lg2>
        <v-btn
          flat large
          to="/awar/personal">
          <v-icon large color="purple">star_border</v-icon>
          奖励管理
        </v-btn>
      </v-flex>

    </v-layout>

    <v-subheader>
      <v-icon class="mr-1" color="indigo">ballot</v-icon>
      科研项目
    </v-subheader>
    <v-divider color="lightgrey"/>
    <v-layout row wrap>
      <v-flex xs6 sm4 md2 lg2>
        <v-btn
          flat large
          to="/proj/personal">
          <v-icon large color="blue">developer_board</v-icon>
          项目管理/申请
        </v-btn>
      </v-flex>

      <v-flex xs6 sm4 md2 lg2>
        <v-btn
          flat large
          to="/ctra/personal">
          <v-icon large color="blue">playlist_add_check</v-icon>
          合同报审
        </v-btn>
      </v-flex>

      <v-flex xs6 sm4 md2 lg2>
        <v-btn
            flat large
            to="/seal/quickseal">
          <v-icon large color="blue">local_play</v-icon>
          快捷用印
        </v-btn>
      </v-flex>

    </v-layout>

    <v-subheader>
      <v-icon class="mr-1" color="green">event_note</v-icon>
      知识产权
    </v-subheader>
    <v-divider color="lightgrey"/>
    <v-layout row wrap>
<!--      <v-flex xs6 sm4 md2 lg2>-->
<!--        <v-btn-->
<!--          flat large-->
<!--          to="/inte/intellectualApp">-->
<!--          <v-icon large color="blue">description</v-icon>-->
<!--          专利申请-->
<!--        </v-btn>-->
<!--      </v-flex>-->

      <v-flex xs6 sm4 md2 lg2>
        <v-btn
          flat large
          to="/inte/InteIntellectualRegist">
          <v-icon large color="blue">playlist_add_check</v-icon>
          专利登记
        </v-btn>
      </v-flex>
    </v-layout>

  </v-container>
</template>
<script>

  export default {
    data() {
      return {}
    }
  }
</script>
